export const googleConfig = {
  name: 'Google Analytics',
  requiredScopes: [
    'https://www.googleapis.com/auth/analytics.readonly',
    'https://www.googleapis.com/auth/analytics.edit',
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile'
  ],
  authEndpoint: 'https://accounts.google.com/o/oauth2/v2/auth',
  tokenEndpoint: 'https://oauth2.googleapis.com/token',
  
  settings: {
    name: {
      type: 'text',
      label: 'Connection Name',
      required: true
    },
    propertyId: {
      type: 'select',
      label: 'Analytics Property',
      required: true,
      loadOptions: 'getProperties'
    }
  }
}; 